import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';

import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";

import "../src/Style/global.scss";
import "../src/Style/responsive.scss";
import "../src/Style/style.scss";
import "../src/Style/table.scss";

import Store from './Store/store';
import { _initDisplayScaleCompensation } from './Helper';

_initDisplayScaleCompensation();

if (process.env.REACT_APP_ENV_DOMAIN !== "localhost") {
  console.log = function () { };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <App />
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
